<template>
    <div id="LogOut">
        <span>{{ title }}</span>
    </div>
</template>

<script>
export default {
    name:"LogOut",
    data(){
        return{
            title:'正在注销账号.'
        }
    },
    methods:{

    },
    created(){
        this.removeAuth();
        this.removeWork();
        this.removeAddr();
        this.$router.push({name:'Login'});
    }
}
</script>

<style scoped>

</style>
